module.exports = __webpack_public_path__ + "img/calculator-style-3.7e130777.png";